import styled from 'styled-components'

export const NewDestinationContent = styled.div``
